export const CaseRequestBreadCrumb = {
    CASE_REQUEST: 'Case Request',
    CASE_REQUEST_DETAILS: 'Case Request Details',
    CASE_REQUEST_OVERVIEW: 'Overview',
    CASE_REQUEST_SUBJECT: 'Subject',
    CASE_REQUEST_FILES: 'Files',
    CASE_REQUEST_HISTORY: 'History'
} as const;
